import React from 'react'

import { compose, withHandlers, withProps } from 'recompose'

import SpendCoreInterstitialImg from 'assets/images/spend-core-interstitial.svg'
import Button from 'components/Button'
import withHeroText, { HeroTextProps } from 'components/HOCs/withHeroText'
import withRemoteStrings from 'components/HOCs/withRemoteStrings'
import Layout from 'components/Layout'
import Nav from 'components/Nav'
import Separator from 'components/Separator'
import { withClickTrack } from 'components/Trackers/ClickTracker'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'

import { Container, Image, Text, Title } from './styled-components'

type Props = {
  header: string
  text: string
  ctaTitle: string
  handleOnPress?: () => void
} & HeroTextProps &
  WithFlowRouterProps

const NextButton = withClickTrack<any, any>(TRACKER_IDS.SPEND_CORE_INTERSTITIAL.NEXT_BUTTON)(Button)

const enhance = compose<Props, {}>(
  withRemoteStrings,
  withHeroText,
  withFlowRouter,
  withProps(({ getRemoteString, heroText }) => {
    return {
      header: getRemoteString('spend_core_interstitial_title', heroText.header),
      text: getRemoteString('spend_core_interstitial_text', heroText.text),
      ctaTitle: getRemoteString('spend_core_interstitial_cta', 'Next'),
    }
  }),
  withHandlers({
    handleOnPress: ({ route }) => () => {
      route({ from: FlowRoute.SpendCoreInterstitial, action: 'continue' })
    },
  }),
)
const SpendCoreInterstitial: React.SFC<Props> = ({ header, text, ctaTitle, handleOnPress }) => (
  <>
    <Nav />
    <Layout>
      <Container>
        <Image src={SpendCoreInterstitialImg} />
        <Title>{header}</Title>
        <Text>{text}</Text>
      </Container>
      <Separator />
      <NextButton onPress={handleOnPress}>{ctaTitle}</NextButton>
    </Layout>
  </>
)
export default enhance(SpendCoreInterstitial)
